var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.5 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#92979b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,13.5V19L59,9.5,49,0V5.5H40.78a12.43,12.43,0,0,0-9.5,4.42L17.65,27.16a8.83,8.83,0,0,1-6.91,3.34H5l-5,8H13.39a11.27,11.27,0,0,0,9-4.48L35.05,17.18a9.81,9.81,0,0,1,7.66-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.5,39A10,10,0,0,0,76,40.09a19,19,0,0,0-37.3-4.57A9,9,0,0,0,24,42.5a8.47,8.47,0,0,0,.06,1,7.5,7.5,0,0,0,.44,15c4,0,51.89.5,56,.5a10,10,0,0,0,0-20Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4926da8297f0f01aae0e510080dbc17f.svg";
export { ForwardRef as ReactComponent };